import { isEmpty } from 'lodash';

export const findCountryByCode = (countries, countryCode) => {
  const countryItem = countries?.find(
    (countryItem) => countryCode === countryItem.Iso3Code,
  );

  return countryItem?.Caption;
};

export const findCountryLabelByValue = (countries, value) => {
  if (!countries || isEmpty(countries) || !value) {
    return '';
  }
  const country = countries.find((item) => item.Iso3Code === value);
  return country?.Caption;
};

export const findStateLabelByValue = (states, value) => {
  if (!states || isEmpty(states) || !value) {
    return '';
  }
  const state = states.find((item) => item?.Code === value);
  return state?.Caption;
};

export const findStateValueByLabel = (states, value) => {
  if (!states || isEmpty(states) || !value) {
    return '';
  }
  const state = states.find((item) => item.Caption === value);
  return state?.Code;
};
